<template>
  <div class="validation-token">
    <div class="validation-token__wrapper">
      <div
        class="validation-token__content"
        :class="{ 'validation-token__content--visible': isIconResultVisible }"
      >
        <VIconResultMessage
          v-if="approved"
          :type="iconResultMessageSuccesData.type"
          :message="iconResultMessageSuccesData.message"
          :iconSvgName="iconResultMessageSuccesData.iconSvgName"
        />

        <VIconResultMessage
          v-else
          :type="iconResultMessageDeniedData.type"
          :message="iconResultMessageDeniedData.message"
          :iconSvgName="iconResultMessageDeniedData.iconSvgName"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VIconResultMessage from '@/components/commons/VIconResultMessage';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ValidationResponses',
  components: {
    VIconResultMessage,
  },
  data: () => ({
    iconResultMessageSuccesData: {
      type: 'success',
      message: ['Token validado com sucesso!'],
      iconSvgName: 'amilIcon',
    },
    iconResultMessageDeniedData: {
      type: 'error',
      message: ['Não foi possível validar o token.'],
      iconSvgName: 'amilIcon',
    },
    isIconResultVisible: false,
    approved: false,
  }),
  computed: {
    ...mapState({
      admission: ({ currentAdmission }) => currentAdmission.data,
    }),
  },

  async created() {
    await this.getAuthorizerValidationResponse();
    this.showIconResult();
    this.moveToNextStep();
  },
  methods: {
    ...mapActions(['global/updateFlowSteps', 'getAuthorizerValidation', 'getAmilTokenValidation']),
    showIconResult() {
      setTimeout(() => {
        this.isIconResultVisible = true;
      }, 500);
    },
    moveToNextStep() {
      setTimeout(() => {
        if (this.approved) {
          this.goToQuestions();
        } else {
          this.goToValidationDenied();
        }
      }, 5000);
    },
    async goToValidationDenied() {
      await this['global/updateFlowSteps']([7, 1]);
      return this.goNextStep('validation_service_desk');
    },
    async goToQuestions() {
      await this['global/updateFlowSteps']([7, 2]);
      return this.goNextStep('questions_conclusion_step');
    },
    async getAuthorizerValidationResponse() {
      this.approved = await this.getAmilTokenValidation();
    },
  },
};
</script>

<style lang="scss" scoped>
.validation-token {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 24px);
  justify-content: center;
  position: relative;
  width: 100%;

  &__wrapper {
    height: 510px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__content {
    align-items: center;
    display: flex;
    flex-direction: column;
    opacity: 0;
    padding: 0 10px 0;
    position: relative;
    transition: opacity 1s ease-in;
    z-index: 0;
    max-width: 240px !important;

    &--visible {
      opacity: 1;
    }

    .circle__thumb .icon-circle {
      bottom: -10px !important;
      right: -10px !important;
    }
  }
}
</style>
